const runLatencyTest = (cb) => {
    const debug = false
    const cinemaDataFront = pmkinoFrontVars && pmkinoFrontVars.cinemaData && pmkinoFrontVars.cinemaData.front ? pmkinoFrontVars.cinemaData.front : null
    const latencyTest = cinemaDataFront && cinemaDataFront.latency_test ? cinemaDataFront.latency_test : null

    if(!latencyTest) {
        cb(true)
        return
    }

    if(!debug && navigator && navigator.connection && navigator.connection.downlink) {
        cb(navigator.connection.downlink > latencyTest.navigator_connection_downlink)
        return
    }

    const arrTimes = []
    const timesToTest = 5
    const tThreshold = latencyTest.time_threshold //ms
    const testImage = window.location.protocol + '//' + window.location.hostname + '/wp-content/themes/pmkino/assets-static/px.gif'
    const dummyImage = new Image()
    let i = 0

    testLatency(function(avg) {
        cb(avg <= tThreshold)
    })

    function testLatency(done) {
        const tStart = new Date().getTime()

        if(i < timesToTest - 1) {
            dummyImage.src = testImage + '?t=' + tStart;
            dummyImage.onload = function() {
                const tEnd = new Date().getTime()
                const tTimeTook = tEnd - tStart
                arrTimes[i] = tTimeTook
                testLatency(done)
                i++
            }
        } else {
            const sum = arrTimes.reduce(function(a, b) { return a + b });
            const avg = sum / arrTimes.length
            done(avg)
        }
    }
}

export default runLatencyTest
